import { UserData } from "@/entities/users/types";
import ChatController from "./ChatController";
import { ChatMessage, dreamUser, mentorUser } from "@/entities/messaging/types";

interface Props {
  selectedUser: UserData;
  messageFromHeader?: string;
  setMessageFromHeader?: any;
  setChatDrawerOpen: React.Dispatch<React.SetStateAction<boolean>>;
  chatDrawerOpen: boolean;
  handleNotification: (messages: ChatMessage[]) => void;
  focusDraftId: string | null;
  onFocusDraftHandled: () => void;
}

const Chat: React.FC<Props> = ({
  selectedUser,
  messageFromHeader,
  setMessageFromHeader,
  setChatDrawerOpen,
  chatDrawerOpen,
  handleNotification,
  focusDraftId,
  onFocusDraftHandled
}: Props) => {
  return (
    <ChatController
      selectedUser={selectedUser}
      dreamerUser={dreamUser}
      mentorUser={mentorUser}
      messageFromHeader={messageFromHeader}
      setMessageFromHeader={setMessageFromHeader}
      setChatDrawerOpen={setChatDrawerOpen}
      chatDrawerOpen={chatDrawerOpen}
      handleNotification={handleNotification}
      focusDraftId={focusDraftId}
      onFocusDraftHandled={onFocusDraftHandled}
    ></ChatController>
  );
};

export default Chat;
